export default "__VITE_ASSET__2d5d51d1__"